import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IHttpResult, interfaces as I } from '@leandredev/dcbm-common-lib';
import * as dcbm from '@leandredev/dcbm-ng-lib';
import { IHttpOption } from '@leandredev/dcbm-ng-lib';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api/api.service';

@Injectable()
export class DepartmentService implements Partial<dcbm.service.DcbmServices> {
  private service: dcbm.service.DcbmServices;

  constructor(private http: HttpClient, private apiService: ApiService) {
    this.service = new dcbm.service.DcbmServices(this.http, true);
    this.service.urlCollection = `${environment.data.api}dcbmservices/`;
  }

  // API methods =======================================================================================================

  getAll<T extends I.IDcbmService>(query: any, options?: dcbm.IHttpOption): Observable<dcbm.IHttpResult<T>> {
    return this.service.getAll(query, options);
  }

  addService<T extends I.IDcbmService, U extends I.IDcbmService>(body: U, query: any, options?: IHttpOption): Observable<IHttpResult<T>> {
    return this.service.addService(body, query, options);
  }

  updateService<T extends I.IDcbmService, U extends I.IDcbmService>(body: U, query: any, options?: IHttpOption): Observable<IHttpResult<T>> {
    return this.service.updateService(body, query, options);
  }

  deleteService<T extends I.IDcbmService>(query: any, id: string, options?: IHttpOption): Observable<IHttpResult<T>> {
    return this.service.deleteService(query, id, options);
  }

  getService<T extends I.IDcbmService>(query: any, id: string, options?: IHttpOption): Observable<IHttpResult<T>> {
    return this.service.getService(query, id, options);
  }

  // ===================================================================================================================

  // #TODO la method est bien dans le service
  public getDCBMServicebyIds(ids: string[]): Observable<I.IDcbmService[]> {
    return this.apiService.collections.DcbmService.get(`_id/${ids.join('/')}/${ids.length}/[/`).pipe(
      dcbm.ApiHelper.resultToArrWEmptyError('Errueur du serveur')
    );
  }
}
